<template>
    <!-- blocker for user without subscription -->
	<BlockerSubscription v-if="isSubscriptionNone" />

    <div v-else class="app-flow">

        <!-- Cards -->
        <div class="app-flow__content">
			<FlowCards :app="app" />
		</div>

        <!-- Navigation -->
        <div v-if="!isFullscreen" class="app-flow__navigation">
			<FlowNavigation :app="app" />
		</div>

		<FlowDebugging v-if="isDebugCard" :app="app" />

    </div>

	<!-- v-if="hasChangedCards" -->
	<FloatingButton
		color="color1"
		justify="right" 
		variant="tonal"
		tooltip="create new flow"
		class="app-flow__button-mobile" 
		:class="{ 'force': isFullscreen }" 
		:elevation="0"
		@click="handleReset">
		<v-icon icon="fa-solid fa-plus"></v-icon>
	</FloatingButton>

	<FloatingButton
		v-if="isAdministrator"
		class="app-flow__button-mobile"
		justify="center" 
		color="secondary" 
		variant="tonal"
		tooltip="settings" 
		:elevation="0"
		@click="handleSettings">
		<v-icon icon="fa-solid fa-gear"></v-icon>
	</FloatingButton>

</template>

<script>
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import BlockerSubscription from '@/components/common/blocker/BlockerSubscription.vue'
import FloatingButton from '@/components/common/button/FloatingButton.vue'
import FlowCards from '@/components/flow/FlowCards.vue'
import FlowDebugging from '@/components/flow/FlowDebugging.vue'
import FlowNavigation from '@/components/flow/FlowNavigation.vue'

export default {
    name: 'Flow',
    components: {
        BlockerSubscription,
        FloatingButton,
        FlowCards,
        FlowDebugging,
        FlowNavigation
    },
    props: {
        app: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters('auth', [
			'isAdministrator',
		]),
        ...mapGetters('flows', [
			'isFullscreen',
			'isDebugCard',
            'hasChanges'
        ]),
        ...mapGetters('subscriptions', [
			'isSubscriptionNone',
			'isSubscriptionTrial'
        ]),

        hasChangedCards() {
            return this.hasChanges(this.app)
        }
    },
    methods: {
        ...mapActions('dialogs', [
            'open'
        ]),

        handleReset() {
            this.open({
				component: "restart",
				payload: {
                    app: this.app
				}
			})
        },
        handleSettings() {
			this.open({
				component: 'settings'
			})
		}
    },
    mounted() {
		// query welcome parameter
		if (this.$route.query.welcome === 'true') {
			// if trial is active, open welcome dialog
			if (this.isSubscriptionTrial) {
				this.open({
					component: 'welcome'
				})
			}
		}
    }
}    
</script>

<style scoped>
.app-flow {
	position: relative;
	width: 100%;
	height: 100vh;
	display: block;
	background: rgb(var(--v-theme-darkbase));
}

.app-flow__content {
	display: flex;
	width: 100%;
	height: 100%;
}

.app-flow__navigation {
	position: absolute;
	top: 0px;
	right: 0px;
	height: 100%;
	min-width: 70px;
	pointer-events: none;
}

.app-flow__button-mobile {
	display: none;
}

.app-flow__button-mobile.force {
	display: block;
}

@media (max-width: 1600px)
{
	.app-flow__navigation {
		min-width: 60px;
	}
}

@media (max-width: 1200px)
{
	.app-flow__navigation {
		min-width: 50px;
	}
}

@media (max-width: 1000px)
{
	.app-flow__navigation {
		display: none;
	}

    .app-flow__button-mobile {
		display: block;
	}
}
</style>